// extracted by mini-css-extract-plugin
export default {"container":"jl-z","blurb":"kl-z","links":"ll-z"};